'use client';

import { Card, Flex, Text, Icon } from '@/_components';
import { useState, type FC, type ReactNode } from 'react';
import styles from './SectionBar.module.css';

interface SectionBarProps {
  title: string;
  color: 'info' | 'success';
  count: number;
  children?: ReactNode;
  defaultExpanded?: boolean;
}

export const SectionBar: FC<SectionBarProps> = ({
  title,
  count,
  color,
  children,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const onToggleExpanded = () => {
    if (children) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <Card className={`${styles.sectionBarCard} ${styles[color]}`}>
      <Flex
        className={`${styles.sectionBar} ${styles[color]}`}
        isYCentered={true}
        isBetween={true}
        padding={4}
        onClick={onToggleExpanded}
      >
        <Text type="small" className={styles.sectionBarText}>
          {title} ({count})
        </Text>
        {children && (
          <Icon
            name={isExpanded ? 'caret-up' : 'caret-down'}
            size={16}
            color="success"
          />
        )}
      </Flex>
      {isExpanded && children && (
        <Flex isColumn={true} gap={4} padding={12}>
          {children}
        </Flex>
      )}
    </Card>
  );
};
